document.addEventListener('DOMContentLoaded', function () {
  const handle = new URLSearchParams(location.search).get('sortby');
  if (handle) {
    const card = [...document.querySelectorAll('.grid__item')]
      .find(card => card.querySelector('.grid-product__link')?.href.includes(handle));
    if (card) {
      card.parentNode.prepend(card);
      card.querySelectorAll('img[loading="lazy"]').forEach(img => {
        img.removeAttribute('loading');
        img.loading = 'eager';
      });
    }
  }
});